<script setup>
// core
import {computed, getCurrentInstance, ref} from "vue";
import {useStore} from "vuex";

// components
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";
import CallNumberView from "@/components/Telephony/CallNumberView.vue";

const isUpdateApiKeyLoading = ref(false)
const {proxy} = getCurrentInstance()
const store = useStore()

const dialogParams = computed(() => store.state.dialogParams);

const updateApiKey = async () => {
    isUpdateApiKeyLoading.value = true
    try {
        await store.dispatch('telephony/updateApiKey', {
            number: dialogParams.value?.number,
            moshaToast: proxy.$moshaToast,
        })
        if (!!store.getters.getNextDialog) {
            store.commit("setDialog", store.getters.getNextDialog);
            store.commit("setNextDialog", "");
        } else {
            store.commit("closeDialog");
        }
    } finally {
        isUpdateApiKeyLoading.value = false
    }
}
</script>

<template>
    <slot name="header_close"/>

    <div class="wrapper_dialog">
        <h3 class="title">
            {{ $t("dialog.refresh_api_key.dialog_title") }}
            <div class="number-block">
                <CallNumberView :number="dialogParams?.number"/>
            </div>
        </h3>

        <div class="content">
            <p class="confirm">{{ $t("dialog.refresh_api_key.title") }}</p>

            <div class="action_container">
                <ButtonLoading :loading="isUpdateApiKeyLoading" @click="updateApiKey">
                    {{ $t("dialog.refresh_api_key.button") }}
                </ButtonLoading>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";
</style>
